import React, { FC, useMemo } from 'react'
import styles from './SearchComponents.module.scss'
import SALink from 'components/SALink'

type PopularSearchesPropsObject = {
  label: string
  link: string
}

type PopularSearchesProps = {
  popularSearches: ReadonlyArray<PopularSearchesPropsObject>
  maxPopularSearches?: number
  setIsFocused: (isFocused: boolean) => void
  onSearch: (query: string) => void
}

const PopularSearches: FC<PopularSearchesProps> = ({
  popularSearches,
  maxPopularSearches = 5,
  setIsFocused,
  onSearch,
}) => {
  const filteredPopularSearches = useMemo(() => popularSearches.slice(0, maxPopularSearches), [
    popularSearches,
    maxPopularSearches,
  ])

  const handlePopularSearchClick = (event: React.MouseEvent<HTMLAnchorElement>, query: string) => {
    event.preventDefault()
    onSearch(query)
    setIsFocused(false)
  }

  if (filteredPopularSearches.length === 0) {
    return null
  }

  return (
    <div className={styles.popularSearchesWrapper}>
      <h5>Popular Searches</h5>
      <div className={styles.popularSearchesContainer}>
        {filteredPopularSearches.map(({ label, link }) => (
          <SALink
            key={label}
            href={link}
            title={label}
            onClick={(e) => handlePopularSearchClick(e, label)}
          >
            <p>{label}</p>
          </SALink>
        ))}
      </div>
    </div>
  )
}

export default PopularSearches
